import React, { useState } from "react"
import * as AppConstants from "../../../../utility/AppConstants"
import * as Utility from "../../../../utility/Utility"
//import InfoRiservatezza from '../../avvisi/InfoRiservatezza';
import TabTitle from "../include/TabTitle"

// modal;
import ModalMob from "../../../modal/ModalMob"
import "Css/table.css"
import { Table } from "@sogei/react-web-components-catalog"
import { Collapsible } from "@sogei/react-web-components-catalog"
import { Messages } from "@sogei/react-web-components-catalog"
import InfoRiservatezza from "@/components/avvisi/InfoRiservatezza"
interface Props {
    codIsa: string
    macroarea: string
    totalePersoneFisiche: any[]
    personeFisicheRe: any[]
    personeFisicheRg: any[]
    personeFisicheRf: any[]
    datiNazionali: any[]
    macroareeTerritoriali: any[]
    anno: string
    infoCodIsa: string[]
}

function TabMacroareeTerritoriali(props: Props) {
    const [
        macroareeTerritoriali,
        macroareeTerritoriali2,
        macroareeTerritoriali3
    ] = props.macroareeTerritoriali
    const anno = Number(props.anno)
    const apriDescrizione = (mobSelezionato: any) => setMob(mobSelezionato)
    const [mob, setMob] = useState([])
    const arr = [
        macroareeTerritoriali?.listaMob ?? [],
        macroareeTerritoriali2?.listaMob?? [],
        macroareeTerritoriali3?.listaMob ??[]
    ]
    const maxLength = Math.max(...arr.map((e) => e.length))
    const arrayToMap = arr.find((f) => f.length == maxLength)
    return (
        <div id="tab-macroaree-territoriali">
            <TabTitle
                title={AppConstants.TITLE_MACROAREE_TERRITORIALI}
                {...props}
            />
            {new Array(5).fill(0).map((_, i) => (
                <Collapsible
                    key={i}
                    cardType="default"
                    title={Utility.getMobArea(i)}
                    titleHeading="h3"
                    body={
                        <div className="row">
                            <div className="col-12 ">
                                <Table
                                    tableHead={
                                        <tr>
                                            <th>
                                                {Utility.getValoreHeader(
                                                    props.codIsa,
                                                    props.macroarea,
                                                    true
                                                )}
                                            </th>
                                            <th className="th-statistiche">
                                                {anno}{" "}
                                                {`(${props.infoCodIsa[0]})`}
                                            </th>
                                            <th className="th-statistiche">
                                                {anno + 1}{" "}
                                                {`(${props.infoCodIsa[1]})`}
                                            </th>
                                            <th className="th-statistiche">
                                                {anno + 2}{" "}
                                                {`(${props.infoCodIsa[2]})`}
                                            </th>
                                        </tr>
                                    }
                                    tableBody={
                                        macroareeTerritoriali !== null &&
                                        macroareeTerritoriali !== undefined ? (
                                            arrayToMap.map(
                                                (mobElem: any, key: number) => (
                                                    <tr
                                                        className="tableStatIsa"
                                                        key={key}
                                                    >
                                                        <th>
                                                            {mobElem.nome}
                                                            <span
                                                                className="far fa-question-circle fa-1x modal-mob"
                                                                style={{
                                                                    cursor: "pointer"
                                                                }}
                                                                data-toggle="modal"
                                                                data-target="#modal-1"
                                                                onClick={() =>
                                                                    apriDescrizione(
                                                                        mobElem
                                                                    )
                                                                }
                                                            />
                                                        </th>

                                                        <td>
                                                            {Utility.valoreMobArea(
                                                                macroareeTerritoriali,
                                                                mobElem.nome,
                                                                i
                                                            )}
                                                        </td>
                                                        <td>
                                                            {Utility.valoreMobArea(
                                                                macroareeTerritoriali2,
                                                                mobElem.nome,
                                                                i
                                                            )}
                                                        </td>
                                                        <td>
                                                            {Utility.valoreMobArea(
                                                                macroareeTerritoriali3,
                                                                mobElem.nome,
                                                                i
                                                            )}
                                                        </td>
                                                    </tr>
                                                )
                                            )
                                        ) : (
                                            <React.Fragment />
                                        )
                                    }
                                    tableOptions={["table-hover"]}
                                >
                                    <caption className="sr-only">
                                        {
                                            AppConstants.TITLE_MACROAREE_TERRITORIALI
                                        }{" "}
                                        -{" "}
                                        {Utility.getValoreHeader(
                                            props.codIsa,
                                            props.macroarea
                                        )}
                                    </caption>
                                </Table>
                            </div>
                        </div>
                    }
                />
            ))}

            {<ModalMob mob={mob} />}
            <InfoRiservatezza />
            <Messages
                successMessages={[]}
                infoMessages={[
                    {
                        text: `Sono escluse le posizioni ISA per le quali non è stato dichiarato il comune`
                    }
                ]}
                warningMessages={[]}
                dangerMessages={[]}
            ></Messages>
        </div>
    )
}

export default TabMacroareeTerritoriali
